import SelectLanguage from './SelectLanguage'
import SelectLanguageWithPlacement from './SelectLanguageWithPlacement'

export default SelectLanguage
export { SelectLanguageWithPlacement }
